import * as React from "react";
import { graphql } from "react-apollo";

import BOPopover from "app/components/BOComponents/BOPopover";
import BOTable, {
  BOBody,
  BORow,
  BOCell,
  BOHeader,
} from "app/components/BOComponents/BOTable/BOTable";

import * as FontAwesome from "react-fontawesome";

import { merchantDetails } from "./MerchantPopoverQuery";

type OwnProps = {
  id: string;
  children: any;
};

type GraphQLProps = {
  data: {
    loading: boolean;
    error?: any;
    merchant?: {
      contact_people: Array<{
        name: string;
        phone: string;
        email: string;
      }>;
      store_infos: Array<{
        address: string;
        address2: string;
        address3: string;
        city: string;
        area_code: string;
        store_area?: { name: string };
        store_province?: { name: string };
      }>;
    };
  };
};

type Props = OwnProps & GraphQLProps;

type State = {
  popoverOpen: boolean;
  popoverEl: any;
};

const ContactPeopleTable = ({ data }) => {
  const body = (
    <BOBody>
      {data ? (
        data.map((contactPerson, index) => (
          <React.Fragment key={index}>
            <BORow>
              <BOCell>
                <b>Name</b>
              </BOCell>
              <BOCell>{contactPerson.name}</BOCell>
            </BORow>
            <BORow>
              <BOCell>
                <b>Phone</b>
              </BOCell>
              <BOCell>{contactPerson.phone}</BOCell>
            </BORow>
            <BORow>
              <BOCell>
                <b>Email</b>
              </BOCell>
              <BOCell>{contactPerson.email}</BOCell>
            </BORow>
          </React.Fragment>
        ))
      ) : (
        <BORow>
          <BOCell colSpan={2}>
            <b>No contact person available</b>
          </BOCell>
        </BORow>
      )}
    </BOBody>
  );

  return (
    <BOTable
      name="merchant_contact_people_popover_data"
      header={<BOHeader title="Contact People" />}
      body={body}
    />
  );
};

const StoreInfosTable = ({ data }) => {
  const body = (
    <BOBody>
      {data ? (
        data.map((storeInfo, index) => (
          <React.Fragment key={index}>
            <BORow>
              <BOCell>
                <b>Address</b>
              </BOCell>
              <BOCell>{storeInfo.address}</BOCell>
            </BORow>
            <BORow>
              <BOCell>
                <b>Address 2</b>
              </BOCell>
              <BOCell>{storeInfo.address2}</BOCell>
            </BORow>
            <BORow>
              <BOCell>
                <b>Address 3</b>
              </BOCell>
              <BOCell>{storeInfo.address3}</BOCell>
            </BORow>
            <BORow>
              <BOCell>
                <b>City</b>
              </BOCell>
              <BOCell>{storeInfo.city}</BOCell>
            </BORow>
            <BORow>
              <BOCell>
                <b>Area</b>
              </BOCell>
              <BOCell>
                {storeInfo.store_area && storeInfo.store_area.name}
              </BOCell>
            </BORow>
            <BORow>
              <BOCell>
                <b>Area code</b>
              </BOCell>
              <BOCell>{storeInfo.area_code}</BOCell>
            </BORow>
            <BORow>
              <BOCell>
                <b>Province</b>
              </BOCell>
              <BOCell>
                {storeInfo.store_province && storeInfo.store_province.name}
              </BOCell>
            </BORow>
          </React.Fragment>
        ))
      ) : (
        <BORow>
          <BOCell colSpan={2}>
            <b>No store infos available</b>
          </BOCell>
        </BORow>
      )}
    </BOBody>
  );

  return (
    <BOTable
      name="merchant_stores_info_popover_data"
      header={<BOHeader title="Stores Info" />}
      body={body}
    />
  );
};

class MerchantPopover extends React.Component<Props, State> {
  state = {
    popoverOpen: false,
    popoverEl: null,
  };

  setPopoverOptions = (event) => {
    event.preventDefault();

    this.setState({
      popoverOpen: true,
      popoverEl: event.currentTarget,
    });
  };

  closePopover = () => {
    this.setState({
      popoverOpen: false,
    });
  };

  render() {
    const { children, data } = this.props;
    const { popoverOpen, popoverEl } = this.state;

    // Handle loading and error states
    const merchant = data.merchant;
    const isLoading = data.loading;
    const hasError = data.error;

    const displayData = (
      <>
        {isLoading ? (
          <div>Loading merchant details...</div>
        ) : hasError ? (
          <div>Error loading merchant details</div>
        ) : (
          <>
            <ContactPeopleTable data={merchant?.contact_people} />
            <StoreInfosTable data={merchant?.store_infos} />
          </>
        )}
      </>
    );

    return (
      <BOPopover
        popover={displayData}
        externalOpen={{ open: popoverOpen, element: popoverEl }}
        externalClose={this.closePopover}
      >
        {children}
        <FontAwesome
          className="merchantPopoverIcon blue"
          name="address-card"
          onClick={this.setPopoverOptions}
        />
      </BOPopover>
    );
  }
}

const merchantDetailsWithGraphql = graphql(merchantDetails, {
  skip: (props: any) => !props || !props.data || !props.data.id,
  options(props: any) {
    return {
      variables: {
        merchantId: props.data.id,
      },
    };
  },
})(MerchantPopover);

export default merchantDetailsWithGraphql;
